// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"161":"emoji-mart-data","340":"emoji-mart"}[chunkId] + ".js";
};